import { zodResolver } from '@hookform/resolvers/zod'
import { Button, CircularProgress, Stack } from '@mui/material'
import { useForm } from 'react-hook-form'
import { CreateAgencyData, useCreateAgency } from '~/features/agencies/hooks/useCreateAgency'
import { routes } from '~/features/routes'
import { FormWrapper } from '~/ui/components/FormWrapper'
import { z } from 'zod'
import { ControlledTextField } from '~/ui/components/ControlledTextField'

const agencyCreateFormSchema = z.object({
  agency_name: z.string().min(1),
  agency_id: z.coerce.number().min(1, 'Agency ID is required'),
  commission: z.coerce.number().min(0).max(1, 'Commission must be between 0 and 1'),
  min_commission: z.coerce.number().min(0),
})
export const AgencyCreateForm = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<CreateAgencyData>({
    defaultValues: {
      agency_name: '',
      agency_id: 0,
      commission: 0,
      min_commission: 0,
    },
    resolver: zodResolver(agencyCreateFormSchema),
  })

  const { mutate: createAgency, isPending } = useCreateAgency()

  const onSubmit = (data: CreateAgencyData) => {
    createAgency(data, {
      onSuccess: () => {
        reset()
      },
    })
  }

  return (
    <FormWrapper backRoute={routes.sales.menu.agencies.route}>
      <Stack gap={2} component="form" onSubmit={handleSubmit(onSubmit)}>
        <ControlledTextField
          name="agency_name"
          control={control}
          label="Agency Name"
          fullWidth
          errors={errors}
        />
        <ControlledTextField
          name="agency_id"
          control={control}
          label="Agency ID"
          fullWidth
          errors={errors}
        />

        <Stack direction="row" gap={2}>
          <ControlledTextField
            name="commission"
            control={control}
            label="Commission %"
            fullWidth
            errors={errors}
          />
          <ControlledTextField
            name="min_commission"
            control={control}
            label="Min Commission"
            fullWidth
            errors={errors}
          />
        </Stack>
        <Button
          type="submit"
          variant="contained"
          disabled={isPending}
          startIcon={isPending ? <CircularProgress size={14} /> : null}
        >
          Create
        </Button>
      </Stack>
    </FormWrapper>
  )
}
